(function () {
  'use strict';

  angular.module('app').component('documentTypesPage', documentTypeListCrtl());

  function documentTypeListCrtl() {
    return {
      bindings: {},
      controller: DocumentTypeListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/document-types/document-types-page.component.html',
    };
  }

  DocumentTypeListCtrl.$inject = [
    'UtilService',
    'AbilityService',
    'DocumentTypeService',
    'LanguageService',
  ];

  function DocumentTypeListCtrl(UtilService, AbilityService, DocumentTypeService, LanguageService) {
    const vm = this;

    // public properties
    // ----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_documenttype_accountadmin'),
    };

    // public methods
    // -----------------------
    vm.createDocumentType = function () {
      DocumentTypeService.openDocumentTypeDetailModal(
        {},
        vm.defaultLanguage,
        vm.additionalLanguages,
        'create',
        getDocumentTypes
      );
    };

    vm.onShowDocumentType = function (documentType, mode) {
      DocumentTypeService.openDocumentTypeDetailModal(
        documentType,
        vm.defaultLanguage,
        vm.additionalLanguages,
        mode
      );
    };

    // private methods
    // -----------------------

    // Initializers
    getAdditionalLanguages();

    function getAdditionalLanguages() {
      LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
        let languages = data.items;

        // vm.defaultLanguage     = $translate.use();
        vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
        vm.additionalLanguages = languages.filter((language) => !language.is_default);

        getDocumentTypes('');
      });
    }

    function getDocumentTypes(selectedItem) {
      vm.filterCriteria = DocumentTypeService.getFilterCriteria();
      vm.filterCriteria.lang = vm.defaultLanguage;
      // vm.filterCriteria.lang = $translate.use();

      vm.loadingItems = true;
      DocumentTypeService.getDocumentTypes(vm.filterCriteria).then(function (data) {
        vm.documentTypes = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        if (selectedItem) {
          vm.UtilService.itemListChanged(selectedItem.id);
        }
      });
    }
  }
})();
